export class Config {

  serviceConfigs: ServiceConfig[];
  inventorySearch: boolean;
  specificManual: boolean;

  constructor() { }

  static toModel(json: string): Config {
    const data = JSON.parse(json);
    const toReturn = new Config();
    toReturn.serviceConfigs = data.serviceConfigs.map((serviceConfig: ServiceConfig) =>
      ServiceConfig.toModel(JSON.stringify(serviceConfig)));
    toReturn.inventorySearch = data.inventorySearch;
    toReturn.specificManual = data.specificManual;
    return toReturn;
  }

}

export class ServiceConfig {
  servicio: string;
  nombreServicio: string;
  plantilla: boolean;
  opciones: boolean;
  direccion: boolean;
  parametros: boolean;
  observaciones: boolean;
  customEmail: boolean;
  instrucciones: boolean;
  downloadAlbaran: boolean;
  editRequestUnit: boolean;

  constructor() { }

  static toModel(json: string): ServiceConfig {
    const data = JSON.parse(json);
    const toReturn = new ServiceConfig();

    toReturn.servicio = data.servicio;
    toReturn.nombreServicio = data.nombreServicio;
    toReturn.plantilla = data.plantilla;
    toReturn.opciones = data.opciones;
    toReturn.direccion = data.direccion;
    toReturn.parametros = data.parametros;
    toReturn.observaciones = data.observaciones;
    toReturn.customEmail = data.customEmail;
    toReturn.instrucciones = data.instrucciones;
    toReturn.downloadAlbaran = data.albaran;
    toReturn.editRequestUnit = data.editRequestUnit;

    return toReturn;
  }

}
